import React, { Component } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import PagesModule from 'modules/pages';
import pageLayout from 'HOC/pageLayout';
import PageTitle from 'components/PageTitle';
import Preloader from 'components/Preloader';
import Button from 'components/Button';
import ROUTES from 'config/routes';

class AdvertisingSponsorship extends Component {
  componentDidMount = () => {
    const { data, onFetch } = this.props;

    if (!data) onFetch();
  }

  render() {
    const { data, isFetching, isAuth } = this.props;

    const seo = data?.seo;
    const content = data?.content;
    const title = content?.title;

    if (isFetching) return (
      <div className="page-body">
        <Preloader />
      </div>
    );

    return (
      <>
        {
          seo &&
          <Helmet>
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="keywords" content={seo.keywords} />
            <meta property="og:title" content={seo.title} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:site_name" content={process.env.REACT_APP_NAME} />
          </Helmet>
        }
        <div className="page-body">
          <PageTitle title={title} align="center" />

          <div className="content-container">
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-8 offset-lg-2">
                  {
                    content &&
                    <div
                      className="content-block"
                      dangerouslySetInnerHTML={{
                        __html: isAuth
                          ? content?.registeredContent
                          : content?.unregisteredContent
                      }}
                    />
                  }
                  {
                    !isAuth &&
                    <div className="text-center">
                      <Button bgColor="green" to={ROUTES.signUp}>REGISTER HERE</Button>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default compose(
  pageLayout(),
  connect(state => ({
    data: state.pages['advertising-sponsorship'],
    isFetching: state.pages.isFetching,
    isFetched: state.pages.isFetched,
    isAuth: state.auth.isAuth,
  }), dispatch => ({
    onFetch: () => dispatch(PagesModule.fetch('advertising-sponsorship'))
  })),
)(AdvertisingSponsorship);
